/**
 * Thumbs up / down on assistant answers (docs/guardian/03 §1.4, audit P-10;
 * 2026-10-21). Optimistic: the rating shows at once and is rolled back if the
 * Backend refuses it. Pressing the active thumb again clears the rating.
 */
import { useCallback } from 'react';
import { rateGuardianTurn } from '../../api/guardianApi';
import { setMessageRating } from '../../utils/turnRating';

export function useChatRating(s) {
  const { setMessages, messagesRef, authTokenRef } = s;

  const rateMessage = useCallback(async (messageId, value) => {
    const message = (messagesRef.current || []).find((m) => m.id === messageId);
    const token = authTokenRef.current;
    if (!message || !message.recordId || !token) return false;
    const previous = message.rating ?? null;
    const next = previous === value ? 0 : value;
    setMessages((prev) => setMessageRating(prev, messageId, next));
    const res = await rateGuardianTurn(token, message.recordId, next);
    if (!res || !res.success) {
      setMessages((prev) => setMessageRating(prev, messageId, previous ?? 0));
      return false;
    }
    return true;
  }, [setMessages, messagesRef, authTokenRef]);

  return { rateMessage };
}
